import { object, string, StringSchema } from 'yup';

import * as constants from '@/constants';
import i18n from '@/settings/i18n';
import { emailSchema } from './email';

export const userSchema = object({
  firstName: string()
    .max(
      constants.NAME_LENGTH,
      i18n.t('ui.error.targeted.maxLength', {
        target: i18n.t('ui.expression.firstName'),
        length: constants.NAME_LENGTH,
      }),
    )
    .matches(
      constants.KANA_KANJI_PATTERN,
      i18n.t('ui.error.targeted.format', {
        target: i18n.t('ui.expression.firstName'),
      }),
    )
    .trim()
    .required(
      i18n.t('ui.error.targeted.required.input', {
        target: i18n.t('ui.expression.firstName'),
      }),
    ),
  lastName: string()
    .max(
      constants.NAME_LENGTH,
      i18n.t('ui.error.targeted.maxLength', {
        target: i18n.t('ui.expression.lastName'),
        length: constants.NAME_LENGTH,
      }),
    )
    .matches(
      constants.KANA_KANJI_PATTERN,
      i18n.t('ui.error.targeted.format', {
        target: i18n.t('ui.expression.lastName'),
      }),
    )
    .trim()
    .required(
      i18n.t('ui.error.targeted.required.input', {
        target: i18n.t('ui.expression.lastName'),
      }),
    ),
  kanaFirstName: string()
    .max(
      constants.NAME_LENGTH,
      i18n.t('ui.error.targeted.maxLength', {
        target: i18n.t('ui.expression.firstNamePhonetic'),
        length: constants.NAME_LENGTH,
      }),
    )
    .matches(
      constants.KANA_PATTERN,
      i18n.t('ui.error.targeted.format', {
        target: i18n.t('ui.expression.firstNamePhonetic'),
      }),
    )
    .trim()
    .required(
      i18n.t('ui.error.targeted.required.input', {
        target: i18n.t('ui.expression.firstNamePhonetic'),
      }),
    ),
  kanaLastName: string()
    .max(
      constants.NAME_LENGTH,
      i18n.t('ui.error.targeted.maxLength', {
        target: i18n.t('ui.expression.lastNamePhonetic'),
        length: constants.NAME_LENGTH,
      }),
    )
    .matches(
      constants.KANA_PATTERN,
      i18n.t('ui.error.targeted.format', {
        target: i18n.t('ui.expression.lastNamePhonetic'),
      }),
    )
    .trim()
    .required(
      i18n.t('ui.error.targeted.required.input', {
        target: i18n.t('ui.expression.lastNamePhonetic'),
      }),
    ),
  // override email fields required
  email: (emailSchema.fields.email as StringSchema).required(
    i18n.t('ui.error.targeted.required.input', {
      target: i18n.t('ui.expression.email'),
    }),
  ),
}).required();
